import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";

export function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0D1B2A]">
      <Navbar />
      <main className="flex-1 pt-[72px]">{children}</main>
      <Footer />
    </div>
  );
}
